<template>
  <div class="navbar-third">
    <div v-if="title" class="navbar-third-title desktop:hidden">
      <span :class="color ? ['text-' + color] : 'text-scheme-light'">{{
        title
      }}</span>
    </div>
    <div class="navbar-third-left">
      <StorageMenuOldNavigationNavbarLinkList :links="links" />
      <div v-if="wysiwyg" class="content" v-html="wysiwyg" />
    </div>
    <div v-if="teaser" class="navbar-third-right">
      <TeaserQuarter
        :title="teaser.fieldTitle"
        :url="getUrl(teaser?.fieldLink)"
        :media="teaser.fieldRefMediaImage"
        :tagline="teaser.fieldTagline"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {
  BlockContentTeaserImageFragment,
  MenuLinkTreeFirstFragment,
} from '#graphql-operations'

withDefaults(
  defineProps<{
    links: MenuLinkTreeFirstFragment[]
    teaser?: BlockContentTeaserImageFragment
    wysiwyg?: string
    title?: string
    color?: string
  }>(),
  {
    links: () => [],
    teaser: undefined,
    wysiwyg: '',
    title: '',
    color: '',
  },
)

function getUrl(link?: { uri?: { path?: string } }) {
  if (link && link.uri && link.uri.path) return link.uri.path
}
</script>

<style lang="postcss">
.navbar-third {
  @apply desktop:flex;
  @screen desktop {
    padding-left: 2rem;
  }
}
.navbar-third-title {
  @apply mb-size-7 text-size-5;
}
.navbar-third-right {
  @apply belowDesktop:mt-size-6 belowDesktop:border-t belowDesktop:border-solid belowDesktop:border-border belowDesktop:pt-size-6;

  @screen desktop {
    flex: 0 0 18rem;
    margin-left: auto;
  }
}
.navbar-third-left {
  .content {
    @apply font-normal text-scheme-invert-ter;
  }
}
</style>
